// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"component-divider-vertical"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M18 3H6V8H18V3Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M18 16H6V21H18V16Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M18 3H6V8H18V3Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M18 16H6V21H18V16Z","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 12L21 12","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ComponentDividerVerticalIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'component-divider-vertical',
    ref,
    icon: element,
  },
));

ComponentDividerVerticalIcon.displayName = 'ComponentDividerVerticalIcon';

export default ComponentDividerVerticalIcon;
